import {useEffect,useState} from "react";
import realtimeDB from "../Utils/api";

const useItemsBusquedas=(string)=>
{
    const [Items, setItems] = useState([]);
    
    useEffect(() => 
    {
        realtimeDB.ref("/Menu").child("CategoriasDOS").on("value",snapshot =>
        {
            var Categorias=[];
            snapshot.forEach(categoria =>
            {
                Categorias.push({id:categoria.key,data:categoria.val()})
            });

            var items=[];
            Categorias.map(categoria =>
            {
                if(categoria.data.Items)
                {
                    const ItemsCategoria=Object.entries(categoria.data.Items);
                    ItemsCategoria.forEach(item => items.push({id:item[0],data:item[1]}));
                }
            });

            items=items.filter(item => 
            {
                var Nombre=String(item.data.Nombre).toUpperCase();
                var Descripcion=String(item.data.Descripcion).toUpperCase();

                var consulta=String(string).toUpperCase();
                if(Nombre.includes(consulta) || Descripcion.includes(consulta))
                {
                    return item;
                }
            });
            
            setItems(items);
        });
    }, []);
    return Items;

}

export default useItemsBusquedas;